import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ControlWrapper from "./o2-control-wrapper";
var g_idSeq = 1;

function O2Checkbox(props) {
  var _useState = useState(function () {
    return "o2-react-theme-checkbox-" + g_idSeq++;
  }),
      generatedId = _useState[0];

  var id = props.id,
      wrapperId = props.wrapperId,
      className = props.className,
      label = props.label,
      inline = props.inline,
      inlineVertical = props.inlineVertical,
      inlineLabel = props.inlineLabel,
      indentLeft = props.indentLeft,
      indentRight = props.indentRight,
      indentBottom = props.indentBottom,
      fakeLabel = props.fakeLabel,
      validationText = props.validationText,
      validationType = props.validationType,
      note = props.note,
      wrapperModifiers = props.wrapperModifiers,
      wrapperClassName = props.wrapperClassName,
      square = props.square,
      controlSize = props.controlSize,
      internal = props.internal,
      block = props.block,
      attributes = _objectWithoutPropertiesLoose(props, ["id", "wrapperId", "className", "label", "inline", "inlineVertical", "inlineLabel", "indentLeft", "indentRight", "indentBottom", "fakeLabel", "validationText", "validationType", "note", "wrapperModifiers", "wrapperClassName", "square", "controlSize", "internal", "block"]);

  var usedId = id || generatedId;
  var classes = classNames(className, "o2-control__custom-checkbox", controlSize ? "o2-control__custom-checkbox--" + controlSize : false, {
    "o2-control__custom-checkbox--square": square,
    "o2-control__custom-checkbox--internal": internal
  });
  var inputClasses = classNames("o2-control__checkbox", validationType ? "o2-control__validation--" + validationType : false);
  return /*#__PURE__*/React.createElement(ControlWrapper, {
    id: wrapperId,
    controlId: usedId,
    note: note,
    inline: inline,
    block: block,
    inlineVertical: inlineVertical,
    inlineLabel: inlineLabel,
    fakeLabel: fakeLabel,
    wrapperModifiers: wrapperModifiers,
    validationType: validationType,
    validationText: validationText,
    wrapperClassName: wrapperClassName,
    indentLeft: indentLeft,
    indentRight: indentRight,
    indentBottom: indentBottom
  }, /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    id: usedId,
    className: inputClasses
  }, attributes)), /*#__PURE__*/React.createElement("label", {
    className: "o2-control__custom-label",
    htmlFor: usedId
  }, label ? label : "")));
}

O2Checkbox.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  inline: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["md"])]),
  inlineVertical: PropTypes.oneOf(["top", "middle", "bottom"]),
  inlineLabel: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["lg"])]),
  indentLeft: PropTypes.bool,
  indentRight: PropTypes.bool,
  indentBottom: PropTypes.bool,
  fakeLabel: PropTypes.bool,
  validationText: PropTypes.string,
  validationType: PropTypes.oneOf(["error", "warning", "success", false]),
  note: PropTypes.string,
  wrapperId: PropTypes.string,
  wrapperModifiers: PropTypes.string,
  wrapperClassName: PropTypes.string,
  square: PropTypes.bool,
  controlSize: PropTypes.oneOf(["small", "large"]),
  internal: PropTypes.bool,
  block: PropTypes.bool
};
export default O2Checkbox;